import { render, staticRenderFns } from "./InviteCustomer.vue?vue&type=template&id=6a397c86&"
import script from "./InviteCustomer.vue?vue&type=script&lang=js&"
export * from "./InviteCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports